module.exports = __webpack_public_path__ + "static/media/Finesse.2f6c41cb.PNG";